module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-image"
  }, [_c('div', {
    staticClass: "container padded bg-danger-lighten-2",
    staticStyle: {
      "opacity": "90%",
      "border-radius": "20px",
      "margin-top": "1.74em",
      "margin-bottom": "1.74em"
    }
  }, [(!_vm.successReg || !_vm.failReg) ? _c('div', [_c('h2', [_vm._v("Register")]), _vm._v(" "), (!_vm.newSystem) ? _c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 16
    }
  }, [_c('select-org-category', {
    attrs: {
      "no-form": ""
    },
    model: {
      value: (_vm.cat),
      callback: function($$v) {
        _vm.cat = $$v
      },
      expression: "cat"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [(_vm.cat) ? _c('check-box', {
    staticStyle: {
      "padding-top": "1.528em",
      "margin-left": "1em"
    },
    attrs: {
      "no-form": "",
      "disabled": !_vm.cat
    },
    model: {
      value: (_vm.existing),
      callback: function($$v) {
        _vm.existing = $$v
      },
      expression: "existing"
    }
  }, [_vm._v("Existing")]) : _vm._e()], 1), _vm._v(" "), (!_vm.existing && _vm.cat) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 4
    }
  }, [_c('org-action', {
    staticClass: "pad-top",
    attrs: {
      "category": _vm.cat,
      "is-disabled": false
    },
    on: {
      "click": function($event) {
        _vm.allowSelectOrgs = false
      }
    },
    model: {
      value: (_vm.contact.organisation),
      callback: function($$v) {
        _vm.$set(_vm.contact, "organisation", $$v)
      },
      expression: "contact.organisation"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (_vm.cat) ? _c('el-row', {
    attrs: {
      "gutter": 10,
      "justify": "center"
    }
  }, [(_vm.existing) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 18,
      "lg": 20
    }
  }, [(_vm.cat !== 'Landlord') ? _c('div', [_c('select-org', {
    attrs: {
      "type": _vm.cat,
      "no-form": "",
      "full-object": "",
      "disabled": !_vm.allowSelectOrgs
    },
    model: {
      value: (_vm.contact.organisation),
      callback: function($$v) {
        _vm.$set(_vm.contact, "organisation", $$v)
      },
      expression: "contact.organisation"
    }
  })], 1) : _c('div', [_c('select-landlord', {
    attrs: {
      "label": "",
      "no-form": "",
      "full-object": "",
      "disabled": !_vm.allowSelectOrgs
    },
    model: {
      value: (_vm.contact.organisation),
      callback: function($$v) {
        _vm.$set(_vm.contact, "organisation", $$v)
      },
      expression: "contact.organisation"
    }
  })], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (_vm.contact.organisation && _vm.contact.organisation.name) ? _c('h2', [_c('small', [_vm._v(_vm._s(_vm.cat) + ": ")]), _vm._v(_vm._s(_vm.contact.organisation.name))]) : _vm._e(), _vm._v(" "), (_vm.contact.organisation && _vm.contact.organisation.name) ? _c('el-form', {
    attrs: {
      "inline": "",
      "label-width": "174px"
    }
  }, [_c('h4', [_vm._v("Contact:")]), _vm._v(" "), _c('el-row', [_c('text-input', {
    attrs: {
      "label": "Full Name",
      "required": ""
    },
    model: {
      value: (_vm.contact.name),
      callback: function($$v) {
        _vm.$set(_vm.contact, "name", $$v)
      },
      expression: "contact.name"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Short Name"
    },
    model: {
      value: (_vm.contact.shortName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "shortName", $$v)
      },
      expression: "contact.shortName"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Job Title"
    },
    model: {
      value: (_vm.contact.jobTitle),
      callback: function($$v) {
        _vm.$set(_vm.contact, "jobTitle", $$v)
      },
      expression: "contact.jobTitle"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('text-input', {
    attrs: {
      "type": "phone",
      "label": "Phone"
    },
    model: {
      value: (_vm.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "phone", $$v)
      },
      expression: "contact.phone"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "type": "email",
      "label": "E-mail",
      "required": ""
    },
    model: {
      value: (_vm.contact.email),
      callback: function($$v) {
        _vm.$set(_vm.contact, "email", $$v)
      },
      expression: "contact.email"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Login Id"
    },
    model: {
      value: (_vm.contact.login),
      callback: function($$v) {
        _vm.$set(_vm.contact, "login", $$v)
      },
      expression: "contact.login"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('password-form', {
    attrs: {
      "toggle": ""
    },
    model: {
      value: (_vm.contact),
      callback: function($$v) {
        _vm.contact = $$v
      },
      expression: "contact"
    }
  })], 1), _vm._v(" "), (!_vm.passwordsMatch) ? _c('el-alert', {
    attrs: {
      "title": "Passwords Don't Match",
      "description": "Passwords don't or less 7 letters or include login name",
      "show-icon": "",
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('check-box', {
    attrs: {
      "label": "E-mail Upload Alerts"
    },
    model: {
      value: (_vm.contact.sendUploadAlerts),
      callback: function($$v) {
        _vm.$set(_vm.contact, "sendUploadAlerts", $$v)
      },
      expression: "contact.sendUploadAlerts"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('check-box', {
    attrs: {
      "label": "E-mail Approval Alerts"
    },
    model: {
      value: (_vm.contact.sendApprovalAlerts),
      callback: function($$v) {
        _vm.$set(_vm.contact, "sendApprovalAlerts", $$v)
      },
      expression: "contact.sendApprovalAlerts"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('center', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.refreshBrowser()
      }
    }
  }, [_vm._v("<< Back")]), _vm._v("\n         \n        "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": !(_vm.contact.name && _vm.contact.email && _vm.contact.login && _vm.passwordsMatch)
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n        Register\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.newSystem && _vm.successReg) ? _c('div', [_c('center', [_vm._v("Successful Registration - Wait for System Admin to approve registration")])], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd14e1dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Register.vue
// module id = 1707
// module chunks = 0